var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class Pjlink {
    constructor(socket, log) {
        this.socket = socket;
        this.displayBlank = false;
        this.power = true;
        this.videoSelection = '11';
        this.timeouts = new Timeouts();
        this.asyncHandlers = [
            {
                name: 'displayBlankQuery',
                regExp: /%1AVMT \?/i,
                callback: (match) => {
                    this.socket.send(`%1AVMT=${this.displayBlank ? '31' : '30'}`);
                },
            },
            {
                name: 'displayBlankSet',
                regExp: /%1AVMT (\d+)/i,
                callback: (match) => {
                    this.displayBlank = match[1] === '31';
                    this.socket.send(`%1AVMT=OK`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /%1POWR \?/i,
                callback: (match) => {
                    this.socket.send(`%1POWR=${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /%1POWR (\d+)/i,
                callback: (match) => {
                    if (match[1]) {
                        this.power = match[1] === '1';
                        this.socket.send(`%1POWR=OK`);
                    }
                },
            },
            {
                name: 'videoQuery',
                regExp: /%1INPT \?/i,
                callback: (match) => {
                    this.socket.send(`%1INPT=${this.videoSelection}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /%1INPT (\d+)/i,
                callback: (match) => {
                    this.videoSelection = match[1];
                    this.socket.send(`%1INPT=OK`);
                },
            },
            {
                name: 'invalidQueryOrSet',
                regExp: /(.+)[\s=]\??.*/i,
                callback: (match) => {
                    this.socket.send(`${match[1]}=ERR}`);
                },
            },
        ];
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.timeouts.delay(1000);
            // Indicate socket connection does not require a hashed passcode with each command.
            this.socket.send(`PJLINK 0`);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '11';
    }
}
Pjlink.emulatorType = 'socketEmulator';
Pjlink.key = '-NEa5nYSs--N8sGD30nS';
